// extracted by mini-css-extract-plugin
export default {"mCard":"iA-z","image":"jA-z","imageNoBackground":"kA-z","imageHasCategory":"lA-z","fullWidth":"mA-z"};